import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const WBS_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Wbs.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('sapCode', 'Entity.Wbs.SapCode')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
];

export const WBS_CONFIG = {
  entityName: 'Wbs',
  localizationKey: 'Controlling::Entity.Wbs',
  fields: WBS_FIELDS,
  permission: 'ControllingSap.Wbs',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
